import { motion, useReducedMotion } from "framer-motion";
import type { FC, ReactNode } from "react";
import { MOTION } from "@/theme/tokens";

/** The steps' slide into a re-sorted order (`useSettledLadderOrder`). */
const REORDER_TRANSITION = { duration: MOTION.DURATION.REORDER / 1000, ease: MOTION.EASE_OUT_POINTS };

type Props = {
	/** The order the ladder's steps are shown in (their ids joined): the slide runs only when it changes. */
	orderKey: string;
	children: ReactNode;
};

/**
 * One ladder step's slot, which slides to its new place when the ladder re-sorts. Keyed to the order alone, so a step
 * growing (an error line) doesn't animate its neighbours; under reduced motion the step jumps straight there.
 */
export const LadderStepSlide: FC<Props> = ({ orderKey, children }) => {
	const reduceMotion = useReducedMotion();
	return (
		<motion.div layout={reduceMotion ? false : "position"} layoutDependency={orderKey} transition={REORDER_TRANSITION}>
			{children}
		</motion.div>
	);
};

/** The `orderKey` for a list of steps in display order. */
export const ladderOrderKey = (steps: readonly { id: string }[]): string => steps.map((step) => step.id).join("|");
